(() => {
  if (window.__brevtechProductFormCartFix) return;
  window.__brevtechProductFormCartFix = true;

  const GENERIC_CART_ERROR = 'We could not add this item to the cart. Please try again.';

  function cartAddUrl() {
    const addUrl = window.routes?.cart_add_url || '/cart/add';
    return addUrl.endsWith('.js') ? addUrl : `${addUrl}.js`;
  }

  async function parseCartResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json') || contentType.includes('text/javascript')) {
      return response.json();
    }

    return {
      status: response.status,
      description:
        response.status === 429
          ? 'Too many cart requests. Please wait a moment and try again.'
          : GENERIC_CART_ERROR,
    };
  }

  function getErrorMessage(response) {
    if (response.description) return response.description;
    if (response.message) return response.message;
    if (Array.isArray(response.errors)) {
      return response.errors.map((error) => error.message || error).join(' ');
    }
    if (response.errors && typeof response.errors === 'object') {
      return Object.values(response.errors).flat().join(' ');
    }
    if (response.errors) return response.errors;
    return GENERIC_CART_ERROR;
  }

  function handleCartError(productForm, response, formData) {
    const errorMessage = getErrorMessage(response);

    publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: formData.get('id'),
      errors: response.errors || errorMessage,
      message: response.message || errorMessage,
    });
    productForm.handleErrorMessage(errorMessage);

    if (Number(response.status) !== 422) return;

    const soldOutMessage = productForm.submitButton.querySelector('.sold-out-message');
    if (!soldOutMessage) return;

    productForm.submitButton.setAttribute('aria-disabled', true);
    productForm.submitButtonText.classList.add('hidden');
    soldOutMessage.classList.remove('hidden');
    productForm.error = true;
  }

  async function fetchCartSections(cart) {
    const sectionIds = cart.getSectionsToRender().map((section) => section.id);
    const response = await fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`);
    const sections = await parseCartResponse(response);

    if (!response.ok || sections.status) {
      throw new Error(getErrorMessage(sections));
    }

    return sections;
  }

  async function onProductFormSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;

    const productForm = form.closest('product-form');
    if (!productForm || !productForm.submitButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (productForm.submitButton.getAttribute('aria-disabled') === 'true') return;

    productForm.handleErrorMessage();
    productForm.error = false;

    productForm.submitButton.setAttribute('aria-disabled', true);
    productForm.submitButton.classList.add('loading');
    productForm.querySelector('.loading__spinner')?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (productForm.cart) {
      productForm.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    try {
      const response = await fetch(cartAddUrl(), config);
      const parsedState = await parseCartResponse(response);

      if (!response.ok || parsedState.status) {
        handleCartError(productForm, parsedState, formData);
        return;
      }

      if (!productForm.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      try {
        parsedState.sections = await fetchCartSections(productForm.cart);
      } catch (error) {
        console.error(error);
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: parsedState,
      });

      const quickAddModal = productForm.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              productForm.cart.renderContents(parsedState);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        productForm.cart.renderContents(parsedState);
      }
    } catch (error) {
      console.error(error);
      handleCartError(
        productForm,
        {
          status: 503,
          description: GENERIC_CART_ERROR,
        },
        formData
      );
    } finally {
      productForm.submitButton.classList.remove('loading');
      if (productForm.cart?.classList.contains('is-empty')) productForm.cart.classList.remove('is-empty');
      if (!productForm.error) productForm.submitButton.removeAttribute('aria-disabled');
      productForm.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }

  document.addEventListener('submit', onProductFormSubmit, true);
})();
